export default {
  data() {
    return {
      callCreditRequestReasons: {
        CALL_CONNECTION_ISSUE: 'Technical / Missed Call / Dropped Call',
        CALL_POLICYHOLDER: 'Consumer already has a policy with my company',
        CALL_FILTERS: 'Did not meet my filters',
        CALL_NOTREQUESTED: 'Consumer did not request lead',
        CALL_INVALIDPHONE: 'Invalid Phone Number',
        CALL_CUSTOMER_NONEXISTING: 'Customer does not exist',
        CALL_LANGUAGEBARRIER: 'Language Barrier',
        CALL_DUPLICATE: 'Duplicate lead',
        CALL_LEADINFOAGED: 'Lead information was aged',
        CALL_EXISTING_POLICYHOLDER: 'Existing Policyholder',
      },
    }
  },
}
